module.exports = __webpack_public_path__ + "media/images/flags/32/Romania-09c8cf8c635a493308850a11d89ec398.png";